<template>
  <v-app>
    <AlertSheet></AlertSheet>
    <LoadingDialog></LoadingDialog>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </v-app>
</template>

<script>
import Vue from 'vue';
import AlertSheet from "@/components/Alert/AlertSheet";
import LoadingDialog from "@/components/Loading/LoadingDialog";

export default Vue.extend({
  name: 'App',
  components: {
    AlertSheet,
    LoadingDialog
  },
  data: () => ({
  }),
  methods: {
    setLanguage(language) {
      this.$i18n.locale = language;
      this.$vuetify.lang.current = language;
    },
  },
  mounted() {
    let local = localStorage.local;
    if (!local) {
      localStorage.local = 'en';
      local = 'en';
    }
    this.setLanguage(local);
  }
});
</script>

<style>

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.pointer {
  cursor: pointer;
  user-select:none;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child{
  margin-right: 8px !important;
}

.v-list-item{
  padding: 0 12px!important;
}

.v-toolbar__content, .v-toolbar__extension{
  align-items: baseline !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
  min-height: 38px !important;
}

.v-text-field--filled .v-label, .v-text-field--full-width .v-label{
  top: 10px !important;
  font-size: 14px !important;
}

.v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot{
  min-height: 42px !important;
}

.v-text-field--filled.v-input--dense .v-label, .v-text-field--full-width.v-input--dense .v-label{
  top: 14px !important;
}

.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
  min-height: 38px !important;
}  

.v-text-field--filled:not(.v-text-field--single-line) input{
  margin-top: 18px !important;
}

.v-toolbar .v-input{
  margin-right: 12px !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default{
  height: 38px;
}

.theme--dark.v-btn-toggle:not(.v-btn-toggle--group){
  background: none !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default{
  height: 38px !important;
}

.v-btn.v-size--default{
  font-size: 0.725rem !important;
}

input{
  font-size: 0.875rem !important;
}

.v-application .title{
  font-size: 1rem !important;
}

.v-list-item__title{
  font-size: 0.825rem !important;
}

.v-list-group__header{
  font-weight: 600;
  color: #909899 !important;
}
.mdi-chevron-down::before{
  color: #909899 !important;
}

.v-list-item--active .v-list-item__title {
  color: white;
}

.v-list-item--active .v-list-item__icon .mdi-chevron-down::before{
  color: white !important
}

.v-list-item--link{
 border-radius: 4px;
} 

.theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before{
  opacity: 0 !important;
}

.v-list .v-list-group__items .v-list-item--active{
   background-color: #2EC4B6;
}

.v-icon.v-icon{
  font-size: 20px
}

.v-btn:not(.v-btn--round).v-size--default{
  min-width: 96px !important;
}

.logout-container .v-btn:not(.v-btn--round).v-size--default { 
  min-width: 48px !important;
}
/*Scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  right:5px;
  position:absolute;
}

::-webkit-scrollbar-thumb {
  background:#505050e7;
  border-radius:10px;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important
}

.medium-height-table .v-data-table__wrapper {
  height: 48vh !important;
}

.login-button {
  width: 380px;
  height: 48px !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.21px;
}

.login-text-field .v-input__slot{
  border-radius: 4px;
  background: rgba(46, 196, 182, 0.12) !important;
  height: 42px !important; 
}

.login-text-field .v-input__append-inner {
  margin-top: 10px !important;
}

input:-webkit-autofill {
  -webkit-box-shadow: 200px 200px 100px rgba(209, 227, 225, 1) inset !important; 
  box-shadow: 200px 200px 100px rgba(209, 227, 225, 1) inset !important; 
}

.reset-password-label {
  text-align: right
}

.reset-password-label::after {
  content: '';
  width: 0px;
  height: 1px;
  display: block;
  background: #909899;
  transition: 300ms;
}

.reset-password-label:hover::after {
  width: 100%;
}

.reset-password-label:hover {
  cursor: pointer;
}

.login-headline {
  color: #000;
  font-family: 'Asap';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.36px;
  width: 60%;
}

.login-tech-label {
  color: #909899;
  font-family: 'Asap';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.18px;
}

.login-text-field .v-text-field__slot {
  margin-left: 6px;
}

.login-container {
  border-radius: 8px;
  border: 1px solid #D0D7D8;
  background: linear-gradient(130deg, rgba(255, 255, 255, 0.40) 10.45%, rgba(255, 255, 255, 0.12) 91.68%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(3px);
  width: 480px;
  height: 482px;
}

.reset-password-container {
  border-radius: 8px;
  background: linear-gradient(130deg, rgba(255, 255, 255, 0.40) 10.45%, rgba(255, 255, 255, 0.12) 91.68%) !important;
  backdrop-filter: blur(3px);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
}

.login-form-container {
  width: 380px;
  margin-top: 4vh;
}

.login-form-container .v-text-field.v-input--dense .v-label, 
.login-text-field .v-label {
  top: -4px !important
}

.login-form-container .v-input .v-label,
.login-text-field .v-label {
  line-height: 14px !important;
}

</style>
